import React from 'react'

const Footer = () => {
    let year = new Date().getFullYear()
    return (
        <div style={{ marginTop: '40px', textAlign: 'center' }}>
            <a href="https://www.liftone.net/">www.liftone.net</a>
            <div className="light-gray-color">&copy; {year} LiftOne</div>
        </div>
    )
}

export default Footer
